export default class Parcelament {

    constructor() {
        this.id = 0;
        this.campaignCompanyPaymentMethodId = 0;
        this.howMany = 0;
        this.description = 0;
        this.default = false;
    }
}